export default __webpack_public_path__ + "static/media/dryCleaningSvg.4c5e9c5c.svg";